module.exports = __webpack_public_path__ + "img/lightning-01.b029ec67.svg";